var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygon4Stroke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 208,
    viewBox: "0 0 239 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.928 103.928L175.678 6.50024L63.1777 6.50024L6.92773 103.928L63.1777 201.356L175.678 201.356L231.928 103.928ZM59.7139 207.356L-4.52097e-06 103.928L59.7139 0.500236L179.142 0.500242L238.855 103.928L179.142 207.356L59.7139 207.356Z",
    fill: "url(#paint0_linear_68_199)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_199",
    x1: 119.428,
    y1: -8.57203,
    x2: 119.428,
    y2: 216.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57C4AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E74D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon4Stroke);
export default __webpack_public_path__ + "static/media/Polygon 4 (Stroke).f049914e9067f970ea547e83483bcc7f.svg";
export { ForwardRef as ReactComponent };